import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../constants';

export const usePersonCardStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: COLORS.cardBg,
    border: `1px solid ${COLORS.border}`,
    borderRadius: 8,
    padding: theme.spacing(2),
    minHeight: 200,
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
  },
  topRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    alignItems: 'flex-start',
  },
  identity: {
    flex: 1,
    minWidth: 0,
  },
  name: {
    fontWeight: 700,
    fontSize: '1.05rem',
    color: COLORS.body,
    marginBottom: theme.spacing(0.5),
  },
  meta: {
    fontSize: '0.8rem',
    color: COLORS.muted,
    lineHeight: 1.5,
  },
  editBtn: {
    alignItems: 'center',
    display: 'flex',
    flexShrink: 0,
    gap: theme.spacing(0.5),
  },
  section: {
    marginTop: theme.spacing(1.5),
  },
  sectionTitle: {
    color: COLORS.muted,
    display: 'block',
    fontSize: '0.72rem',
    fontWeight: 700,
    letterSpacing: 0.2,
    textTransform: 'uppercase',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.75),
    marginTop: theme.spacing(1.5),
    paddingTop: theme.spacing(1.5),
    borderTop: `1px dashed ${COLORS.border}`,
  },
  attributeChip: {
    fontWeight: 400,
    maxWidth: '100%',
    // MUI Chip forces a fixed height (e.g. 24px on size="small"); allow multi-line labels to grow the box.
    height: 'auto',
    minHeight: 24,
    alignItems: 'flex-start',
    alignSelf: 'flex-start',
    '&.MuiChip-sizeSmall': {
      height: 'auto',
    },
    '& .MuiChip-label': {
      fontWeight: 400,
      whiteSpace: 'normal',
      overflow: 'visible',
      textOverflow: 'clip',
      lineHeight: 1.45,
      paddingTop: 6,
      paddingBottom: 6,
    },
  },
  attributeChipLabel: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5),
    flexWrap: 'wrap',
    fontWeight: 400,
    maxWidth: '100%',
    lineHeight: 1.45,
    boxSizing: 'border-box',
  },
  attributeName: {
    fontWeight: 400,
  },
  attributeValueCode: {
    fontFamily:
      'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
    fontSize: '0.8125rem',
    fontWeight: 400,
    padding: '2px 6px',
    borderRadius: 4,
    backgroundColor: 'rgba(0, 0, 0, 0.06)',
    color: COLORS.body,
  },
}));
